import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { lazy } from 'react';

import { Label } from '@ifs-gcp/components';
import type { IConditionHandler, ITemplateNode } from '@ifs-gcp/core';
import type { QuestionTextChild } from '@ifs-gcp/core/models';

import { getTranslation } from '@/utils/translations';

import styles from './question-text.module.scss';

const LazyHintModal = lazy(() => import('@/components/hint-modal/hint-modal'));

interface QuestionTextProps {
  language: string;
  element: ITemplateNode<QuestionTextChild>;
  conditions: IConditionHandler;
}

export const QuestionText = ({ language, element, conditions }: QuestionTextProps) => {
  const { text } = element.props;

  const resolvedText = Array.isArray(text)
    ? text.find((value) => conditions.validate(value.visibilityCondition))?.text
    : text;

  return (
    <Label className={styles.questionText}>
      {parse(DOMPurify.sanitize(getTranslation(resolvedText, language)))}

      {element.children?.map((hint) => (
        <LazyHintModal key={hint.props.id} element={hint} />
      ))}
    </Label>
  );
};
